import { Injectable, OnDestroy, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Subscription, interval } from 'rxjs';
import { SnackMessageService } from 'src/app/shared/services/snack-message.service';

@Injectable({
  providedIn: 'root',
})
export class WebServiceWorker implements OnDestroy {
  swUpdate = inject(SwUpdate);
  private snackMessageService = inject(SnackMessageService);

  serviceSubscriptions: Subscription[] = [];

  constructor() {
    this.initialize();
  }

  initialize() {
    if (this.swUpdate.isEnabled) {
      // If service worker is enabled
      console.warn('Service worker running.');
      this.serviceSubscriptions.push(interval(15 * 1000).subscribe(() => this.swUpdate.checkForUpdate()));
      this.serviceSubscriptions.push(
        this.swUpdate.versionUpdates.subscribe(evt => {
          if (evt.type === 'VERSION_READY') {
            this.snackMessageService.openNewPortalVersionWarning();
          }
        })
      );
      this.serviceSubscriptions.push(
        this.swUpdate.unrecoverable.subscribe(() => {
          console.warn('App is in unrecoverable state. Reloading to avoid chunk load issue.');
          this.snackMessageService.openNewPortalVersionWarning();
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.serviceSubscriptions?.forEach(x => x?.unsubscribe());
  }
}
